import { gsap, ScrollTrigger, DrawSVGPlugin } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin)

export function keyline(element: HTMLElement, trigger?: HTMLElement, start?: string, end?: string, markers?: boolean) {
  const parentSection = element.closest('section')
  let path: SVGPathElement | null

  // get inner svg path
  path = element.querySelector('path') || element.querySelector('rect')

  const keyline = gsap
    .timeline({
      scrollTrigger: {
        trigger: trigger || parentSection,
        start: start || 'top center',
        end: end || 'bottom center',
        scrub: 0.25,
        invalidateOnRefresh: true,
        markers: markers || false
      }
    })
    .fromTo(
      path,
      { drawSVG: '0%' },
      {
        drawSVG: '100%',
        ease: 'none'
      }
    )
}
